<template>
  <svg
    id="Group_17246"
    data-name="Group 17246"
    viewBox="0 0 16 16"
    class="image-icon"
  >
    <circle
      id="Ellipse_728"
      data-name="Ellipse 728"
      cx="1.5"
      cy="1.5"
      r="1.5"
      transform="translate(10 4)"
    />
    <path
      id="Path_8599"
      data-name="Path 8599"
      d="M15,0H1A1,1,0,0,0,0,1V15a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V1A1,1,0,0,0,15,0ZM14,11.122,11.445,8.377a.5.5,0,0,0-.357-.159.468.468,0,0,0-.362.146l-.965.965L6.984,6.324a.476.476,0,0,0-.389-.16.5.5,0,0,0-.374.194L2,11.851V2H14Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ImageIcon',
};
</script>

<style scoped lang="scss">
.image-icon > * {
  fill: var(--feature-color, main.$npGray);
}
</style>

